import React, { FC } from 'react';
import Modal from '../../Modal/NewModal';
import { Button } from '../../Button';

interface CancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCancelChanges: any;
}

export const CancelModal: FC<CancelModalProps> = ({ isOpen, onClose, onCancelChanges }) => {
  const handleRevertChanges = () => {
    onCancelChanges();
    onClose();
  };

  const CustomButtons = () => (
    <div className="flex gap-4">
      <Button title="Cancel" kind="secondary" onClick={onClose} />
      <Button title="Confirm and revert" type="submit" onClick={handleRevertChanges} />
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="Cancel changes"
      customFooterActions={{
        right: <CustomButtons />
      }}
      size="small"
    >
      <div className="p-6 pb-20 text-2xl" data-testid="marketing-cancel-modal">
        Are you sure you want to cancel? All your changes will be removed.
      </div>
    </Modal>
  );
};
